import type {
  BrowseSection,
  BrowseSectionsResponse
} from '@api/fetchers/goal/test-tab/types';

import { CATEGORY_TAB } from './constants';
import type { AllTestsCategoryTabId } from './types';

const API_ID_TO_CATEGORY_TAB: Record<string, AllTestsCategoryTabId> = {
  UPCOMING: CATEGORY_TAB.UPCOMING,
  LIVE: CATEGORY_TAB.ONGOING,
  PYT: CATEGORY_TAB.PREVIOUS_YEAR,
  PAST: CATEGORY_TAB.PAST,
  EDUCATOR_TESTS: CATEGORY_TAB.EDUCATOR,
  TEST_SERIES: CATEGORY_TAB.ALL_SERIES
};

const toNumber = (value: unknown): number => {
  const parsed = Number(value);

  return Number.isFinite(parsed) ? parsed : 0;
};

export const getCategoryTabIdFromBrowseSectionId = (
  sectionId?: string
): AllTestsCategoryTabId | null => {
  if (!sectionId) {
    return null;
  }

  return API_ID_TO_CATEGORY_TAB[sectionId] || null;
};

export const normalizeBrowseSections = (
  response?: BrowseSectionsResponse | null
): BrowseSection[] => {
  const rawSections = response?.sections || [];

  return rawSections
    .map((section) => ({
      id: section.id,
      heading: section.heading || '',
      description: section.description || '',
      iconUrl: section.iconUrl,
      rank: toNumber(section.rank),
      totalTestCount: toNumber(section.totalTestCount)
    }))
    .filter(
      (section) =>
        Boolean(section.heading) &&
        Boolean(getCategoryTabIdFromBrowseSectionId(section.id))
    )
    .sort((left, right) => left.rank - right.rank);
};

export const getBrowseCountLabel = (section: BrowseSection): string => {
  const count = section.totalTestCount;
  const isSeries =
    getCategoryTabIdFromBrowseSectionId(section.id) === CATEGORY_TAB.ALL_SERIES;

  if (isSeries) {
    return count === 1 ? '1 series' : `${count} series`;
  }

  return count === 1 ? '1 test' : `${count} tests`;
};
